import MuiButton from '@mui/material/Button';
import { themeColors } from '../theme/theme';

export function Button({ children, size = 'medium', variant = 'contained', style, ...props }) {
  return (
    <MuiButton
      variant={variant}
      size={size}
      style={{
        fontFamily: themeColors.fontFamily,
        background: variant === 'contained' ? themeColors.primaryColor : undefined,
        color: variant === 'contained' ? '#fff' : themeColors.primaryColor,
        borderRadius: 6,
        fontWeight: 600,
        textTransform: 'none', // Prevent all-caps
        fontSize: '1rem', // Consistent with MUI default
        ...style,
      }}
      {...props}
    >
      {children}
    </MuiButton>
  );
}
